import { Button, Card } from 'antd';
import styled from 'styled-components';

export const ProfileCard = styled(Card)`
  height: unset;
`;

export const Btn = styled(Button)`
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  padding: 0;
  height: unset;
  color: var(--secondary-color);
`;

export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h2`
  margin: 0;
  font-weight: 700;
  font-size: 1.5rem;
`;

export const SubTitle = styled.h3`
  margin: 0;
  font-size: 1rem;
  color: var(--gray-6);
`;
